// Web mock for `react-native-orientation-director`.
//
// The real module resolves the `OrientationDirector` TurboModule at import time
// via `TurboModuleRegistry.getEnforcing(...)`, which throws on web because
// `react-native-web` does not provide `TurboModuleRegistry`. Browsers have no
// programmatic interface-orientation lock we care about, so every method is a
// no-op here. The enum values mirror the native package exactly.

export const Orientation = {
  unknown: 0,
  portrait: 1,
  landscapeRight: 2,
  portraitUpsideDown: 3,
  landscapeLeft: 4,
  landscape: 5,
  faceUp: 6,
  faceDown: 7,
}

export const OrientationType = {
  device: 'device',
  interface: 'interface',
}

export const AutoRotation = {
  unknown: 0,
  enabled: 1,
  disabled: 2,
}

const noopSubscription = { remove() {} }

const OrientationDirector = {
  setHumanReadableOrientations() {},
  setHumanReadableAutoRotations() {},
  getInterfaceOrientation: () => Promise.resolve(Orientation.portrait),
  getDeviceOrientation: () => Promise.resolve(Orientation.portrait),
  lockTo() {},
  unlock() {},
  isLocked: () => false,
  isAutoRotationEnabled: () => AutoRotation.unknown,
  resetSupportedInterfaceOrientations() {},
  listenForDeviceOrientationChanges: () => noopSubscription,
  listenForInterfaceOrientationChanges: () => noopSubscription,
  listenForLockChanges: () => noopSubscription,
  convertOrientationToHumanReadableString: () => '',
  convertAutoRotationToHumanReadableString: () => '',
  isLockableOrientation: () => false,
}

export const useDeviceOrientation = () => Orientation.portrait
export const useInterfaceOrientation = () => Orientation.portrait
export const useIsInterfaceOrientationLocked = () => false

export default OrientationDirector
